import { render, staticRenderFns } from "./ComposeMailDialog.vue?vue&type=template&id=33b657ce&scoped=true"
import script from "./ComposeMailDialog.vue?vue&type=script&lang=js"
export * from "./ComposeMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b657ce",
  null
  
)

export default component.exports